<template>
  <nav class="bg-blue-900 bg-opacity-80 backdrop-blur-sm p-4 sticky top-0 z-50 shadow-lg" style="font-family: 'Oswald', sans-serif;">
    <div class="container mx-auto flex justify-between items-center">
      <router-link to="/" class="flex items-center text-white hover:text-white min-w-0">
        <img src="../assets/images/logo.png" alt="Trevia Systems Logo" class="h-9 md:h-12 mr-2 md:mr-3 shrink-0" />
        <span class="font-semibold text-sm md:text-xl whitespace-nowrap truncate">Trevia Systems & Services</span>
      </router-link>

      <div class="hidden md:flex space-x-6 text-lg">
        <router-link to="/" class="text-white hover:text-yellow-500 transition-colors duration-300">Home</router-link>
        <router-link to="/about" class="text-white hover:text-yellow-500 transition-colors duration-300">About Us</router-link>
        <router-link to="/services" class="text-white hover:text-yellow-500 transition-colors duration-300">Services</router-link>
        <router-link to="/contact" class="text-white hover:text-yellow-500 transition-colors duration-300">Contact</router-link>
      </div>

      <button
        @click="toggleMobileMenu"
        class="md:hidden text-white focus:outline-none transition-colors duration-300 shrink-0 ml-2"
        :class="{ 'hamburger-open': mobileMenuOpen }"
        aria-label="Toggle mobile menu"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            v-if="!mobileMenuOpen"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16m-7 6h7"
          />
          <path
            v-else
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      <Transition name="menu-fade">
        <div
          v-if="mobileMenuOpen"
          class="md:hidden absolute top-full right-4 left-4 sm:left-auto sm:w-64 bg-[#0A1930] p-2 rounded-lg shadow-2xl z-50 border border-white/10 mt-2 overflow-hidden"
        >
          <router-link
            to="/"
            class="block px-4 py-3 text-white text-sm font-medium hover:bg-white/5 hover:text-yellow-500 rounded-md transition-colors duration-200"
            @click="closeMobileMenu"
          >
            Home
          </router-link>
          <router-link
            to="/about"
            class="block px-4 py-3 text-white text-sm font-medium hover:bg-white/5 hover:text-yellow-500 rounded-md transition-colors duration-200"
            @click="closeMobileMenu"
          >
            About Us
          </router-link>
          <router-link
            to="/services"
            class="block px-4 py-3 text-white text-sm font-medium hover:bg-white/5 hover:text-yellow-500 rounded-md transition-colors duration-200"
            @click="closeMobileMenu"
          >
            Services
          </router-link>
          <router-link
            to="/contact"
            class="block px-4 py-3 text-white text-sm font-medium hover:bg-white/5 hover:text-yellow-500 rounded-md transition-colors duration-200"
            @click="closeMobileMenu"
          >
            Contact
          </router-link>
        </div>
      </Transition>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue';

const mobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value;
};

const closeMobileMenu = () => {
  mobileMenuOpen.value = false;
};
</script>

<style scoped>
.hamburger-open svg {
  color: #facc15;
}

.router-link-active,
.router-link-exact-active {
  color: #facc15 !important;
  font-weight: 600;
}

.menu-fade-enter-active,
.menu-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.menu-fade-enter-from,
.menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>